import { Link } from 'react-router-dom';
import { Facebook, Mail, Phone, MessageCircle, Star } from 'lucide-react';
import DiscountBanner from './DiscountBanner';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      {/* Discount Banner - Bottom */}
      <DiscountBanner size="small" />
      
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* About Column */}
          <div className="footer-column">
            <div className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_whisker-guardians/artifacts/r7gal1h2_clear%20background.png" 
                alt="Maid for Cats Logo" 
                className="footer-logo-image"
              />
            </div>
            <p className="footer-about">
              Professional in-home cat sitting and home guardian services in Walsall and surrounding areas. Your cats stay comfortable at home while we care for them.
            </p>
          </div>

          {/* Quick Links Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services & Pricing</Link></li>
              <li><Link to="/home-guardians">Home Guardians</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/service-area">Service Area</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Services Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Our Services</h3>
            <ul className="footer-links">
              <li><Link to="/services">Once Daily Visits</Link></li>
              <li><Link to="/services">Twice Daily Visits</Link></li>
              <li><Link to="/services">VIP Extended Visits</Link></li>
              <li><Link to="/home-guardians">Home Guardians</Link></li>
              <li><Link to="/services">Medication Administration</Link></li>
              <li><Link to="/contact">Free Meet & Greet</Link></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Get In Touch</h3>
            <ul className="footer-contact">
              <li>
                <a href="tel:07344414860" className="contact-item">
                  <Phone size={18} />
                  <span>07344 414860</span>
                </a>
              </li>
              <li>
                <a href="mailto:Enquiries@maidforcats.co.uk" className="contact-item">
                  <Mail size={18} />
                  <span>Enquiries@maidforcats.co.uk</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/447344414860" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="contact-item whatsapp"
                >
                  <MessageCircle size={18} />
                  <span>WhatsApp Us</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.facebook.com/share/1Agoup3V4a/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="contact-item facebook"
                >
                  <Facebook size={18} />
                  <span>Follow Us on Facebook</span>
                </a>
              </li>
            </ul>
            <div className="footer-review-link">
              <a 
                href="https://g.page/r/CZIipnthC_CTEBI/review" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="review-button"
              >
                <Star size={18} />
                <span>Please leave a paw-sitive review</span>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Maid for Cats. All rights reserved.
            </p>
            <p className="footer-tagline">
              Professional Cat Sitting in Walsall | In-Home Cat Care | Home Guardians Service
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
